var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 614.25 700.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #350069;\n      }\n      .skin-dark {\n        fill: #d8aa88;\n      }\n      .skin {\n        fill: #ecbc94;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566,701H44.62C69.68,575.15,176.87,480.59,305.3,480.59S540.92,575.15,566,701Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin-dark",
    d: "M318.07,629.48a16.93,16.93,0,0,1-29.38-.19l-36.14-64-50.67-89.69,102,1.54,102,1.55-51.34,88.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M538.21,275c0,74.44-43,150.49-100,200-34.17,29.71-81.55,44.41-104.69,58.75a52.83,52.83,0,0,1-55.62,0C252.54,518,198.46,499.89,161.21,466c-53.39-48.58-88-120.84-88-191,0-151.88,104.1-275,232.5-275S538.21,123.12,538.21,275Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M104.16,283a51,51,0,0,1-68.74,21.84c-14-7.23-25.76-31.21-33.48-51a28.08,28.08,0,0,1,19.41-37.49c20.62-5.12,47-9.31,61-2.09A51,51,0,0,1,104.16,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M510.1,278.28a51,51,0,0,0,68.74,21.84c13.95-7.23,25.76-31.2,33.48-51a28.09,28.09,0,0,0-19.42-37.49c-20.62-5.12-47-9.31-61-2.09A51,51,0,0,0,510.1,278.28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset9);
export default __webpack_public_path__ + "static/media/Asset 9.233f4bca.svg";
export { ForwardRef as ReactComponent };